import * as React from 'react';
import './Spinner.css';

export type SpinnerProps = { modifier?: string };
export const Spinner: React.SFC<SpinnerProps> = (props) => {
    return (
        <div className="square">
            <div className="square__side square__side--top"/>
            <div className="square__side square__side--right"/>
            <div className="square__side square__side--bottom"/>
            <div className="square__side square__side--left"/>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/Components/Spinner/Spinner.tsx